import React from 'react';

import { makeStyles, createStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

const useStyles = makeStyles(() => createStyles({
  section: {
    display: 'flex',
    flex: 1,
    padding: '12px 24px',
    justifyContent: 'space-between',
    alignItems: 'baseline',
  },
  borderBottom: {
    borderBottom: '1px solid rgba(224, 224, 224, 1)',
  },
}));

interface IProps {
  children: React.ReactNode;
  borderBottom?: boolean;
  className?: string;
}

const FieldWrap: React.FC<IProps> = ({ children, borderBottom, className }) => {
  const classes = useStyles();
  return (
    <div className={classNames(classes.section, className, { [classes.borderBottom]: borderBottom })}>
      { children }
    </div>
  );
};

export default FieldWrap;
